const SIGN_IN = 'api/admin/admin_login/';
const REFRESH_TOKEN = 'api/refresh-token/';

//Project-updates
const PROJECT_UPDATES_HISTORY = 'api/project/project_update_details';
const PROJECT_LIST = 'api/project/project_list';
const CONSTRUCTION_UPDATE = 'api/project/projects_mediaUpload/';
const CITY_LIST = 'api/project/city_list/';
const PROJECT_UPDATE_ANALYTICS_DETAILS = 'api/analytics/event_analytics/construction_update_analytics/';

//analytics
const EVENTS_CHART_DATA = 'api/analytics/event_analytics/report/';
const SCREEN_ANALYTICS = 'api/analytics/event_analytics/screens';
const EVENT_ANALYTICS = 'api/analytics/event_analytics/screens/events';
const EVENT_DETAILS = 'api/analytics/event_analytics/user_event/';
const KPI_STATS = 'api/project/stats/';
const GEO_REPORTS = 'api/users/geo_breakdown';
const TECH_REPORT = 'api/users/tech_overview';
const CUSTOMER_LIST = 'api/users/user_list';
const USER_EVENTS = 'api/users/event_analytics/user_event_search/';
const USER_APP_DETAILS = 'api/users/event_analytics/user_custom_activity/';
const EVENT_TIMELINE = 'api/analytics/event_analytics/event_timeline';
const PROJECTWISE_EVENTS = 'api/analytics/event_analytics/project_event_count';
const APP_INSTALLS_REPORT = 'api/app_review/store_analytics';
const DOWNLOAD_REPORTS = 'api/analytics/download/';

//Admin Management
const LIST_PERMISSIONS = 'api/admin/list_permissions';
const CREATE_ADMIN = 'api/admin/create-admin-user/';
const FETCH_ADMINS = 'api/admin/list_admin_users/';
const UPDATE_ADMIN = 'api/admin/update-admin-user/';
const DELETE_ADMIN = 'api/admin/delete-admin-user/';
const LOGOUT = 'api/admin/logout-admin-user/';
const FORGOT_PASSWORD = 'api/admin/forgot_password/';

//Project Hierrachy
const PROJECTS_BULK_UPLOAD = 'api/project/bulk_upload/';
const PROJECTS_DATA = 'api/project/project_hierarchy/';

//Reviews
const ALL_REVIEWS = 'api/app_review/reviews/';
const REVIEW_DETAILS = 'api/app_review/review/';
const REPLY_TO_REVIEW = 'api/app_review/review/reply/';

//Content
const APP_CONTENT = 'api/apps_screen/list_content/';
const PREVIEW_LINKS = 'api/apps_screen/screen_preview/';
const FETCH_FAQS = 'api/content/faq/list/';
const FAQS_CATEGORY = 'api/content/faq/category/';
const FAQS_SUBCATEGORY = 'api/content/faq/subcategory/';
const FAQS_QNA = 'api/content/faq/entry/';
const CARE_FAIR_EVENTS_LIST = 'api/care_fair/list/';
const CARE_FAIR_EVENTS = 'api/care_fair/entry/';

export {
  SIGN_IN,
  REFRESH_TOKEN,
  PROJECT_UPDATES_HISTORY,
  PROJECT_LIST,
  CITY_LIST,
  PROJECT_UPDATE_ANALYTICS_DETAILS,
  CONSTRUCTION_UPDATE,
  EVENTS_CHART_DATA,
  SCREEN_ANALYTICS,
  EVENT_ANALYTICS,
  EVENT_DETAILS,
  KPI_STATS,
  GEO_REPORTS,
  LIST_PERMISSIONS,
  TECH_REPORT,
  CUSTOMER_LIST,
  USER_EVENTS,
  USER_APP_DETAILS,
  EVENT_TIMELINE,
  PROJECTWISE_EVENTS,
  APP_INSTALLS_REPORT,
  DOWNLOAD_REPORTS,
  CREATE_ADMIN,
  FETCH_ADMINS,
  UPDATE_ADMIN,
  DELETE_ADMIN,
  LOGOUT,
  FORGOT_PASSWORD,
  PROJECTS_BULK_UPLOAD,
  PROJECTS_DATA,
  ALL_REVIEWS,
  REVIEW_DETAILS,
  REPLY_TO_REVIEW,
  APP_CONTENT,
  PREVIEW_LINKS,
  FETCH_FAQS,
  FAQS_CATEGORY,
  FAQS_SUBCATEGORY,
  FAQS_QNA,
  CARE_FAIR_EVENTS_LIST,
  CARE_FAIR_EVENTS,
};
